/**
 * Ownership for in-flight draft saves and media hydration.
 * A completion may touch wizard state only while generation, org, and
 * sequence still match the operation that started it.
 */

export interface DraftOwner {
  generation: number;
  orgId: string | null;
  draftId: string | null;
}

export interface DraftSaveCapture {
  generation: number;
  orgId: string | null;
  draftId: string | null;
  persistSeq: number;
}

export interface DraftMediaCapture {
  generation: number;
  orgId: string | null;
  draftId: string | null;
}

export function captureDraftSave(owner: DraftOwner, persistSeq: number): DraftSaveCapture {
  return {
    generation: owner.generation,
    orgId: owner.orgId,
    draftId: owner.draftId,
    persistSeq,
  };
}

export function draftSaveStillCurrent(captured: DraftSaveCapture, owner: DraftOwner, persistSeq: number): boolean {
  return captured.generation === owner.generation
    && captured.orgId === owner.orgId
    && captured.persistSeq === persistSeq;
}

export function captureDraftMedia(owner: DraftOwner, draftId: string): DraftMediaCapture {
  return { generation: owner.generation, orgId: owner.orgId, draftId };
}

export function draftMediaStillCurrent(captured: DraftMediaCapture, owner: DraftOwner): boolean {
  return captured.generation === owner.generation
    && captured.orgId === owner.orgId
    && captured.draftId === owner.draftId;
}
